module.exports = __webpack_public_path__ + "img/pvc_650g_farbauswahl_gelb_orange_gruen_rot.638e2b00.jpg";